import { IAppointment, IDepartment, IPatient, IResearcher, ISurvey, IUnit } from "../../../constants/types"
import { IPharmacyItem } from "../Pharmacy/types";
import { SurgeryRequestData } from "./RequestForm";

export interface IService{
    id:number,
    name:string,
    type:number,
    code:string,
    category:string,
}

export interface IServiceInvestigation{
    id:number,
    name:string,
    description:string,
    type:number,
    code:string,
    service:IService,
    price:number,
    external:number,
    survey:any,
    billable:any
}

export enum RequestStatus {
    PENDING_APPROVAL = 0,
    PENDING_PAYMENT = 1,
    ACCEPTED = 2,
    SOME_ACCEPTED = 3,
    DENIED = 4,
    CANCELED = 5,
    EXPIRED = 6,
    COMPLETED = 7,
    IN_PROGRESS = 8,
    INCOMPLETE = 9,
    INCOMPLETE_ACCEPTED = 10, //Pensada para farmacia
    CANCELED_BY_USER = 11,
    PENDING_ANESTHESIOLOGIST = 12,
    PENDING_PURCHASE_SURGERY_PROTHESIS = 13,
    ANESTHESIOLOGIST_REJECTED = 14,
    PAYMENT_COMPLETED = 15,
    READY_FOR_SURGERY = 16,
    ANESTHESIOLOGIST_ACCEPTED = 17,
    CHECKED_IN = 18,
    // SHER-908: a cordonnerie order ends when the patient collects the material, not when
    // the shoe is finished. Mirror of the API value; reachable only from COMPLETED on SHOE.
    MATERIAL_DELIVERED = 19,
    // SHER-935: the VPA-first pathway re-enters "awaiting payment" for the surgical balance, so
    // PENDING_PAYMENT alone could not say whether the pre-anaesthesia visit had happened, and a
    // chip renders a status and nothing else. Mirror of the API values; surgical only.
    PENDING_PAYMENT_AFTER_VPA = 20,
    PAYMENT_COMPLETED_AFTER_VPA = 21,

}

export enum BillStatus {
    PAID = 1,
    PENDING_PAYMENT = 0,
}

export interface IRequestServiceInvestigation{
    id:number,
    request:IRequest,
    status : RequestStatus,
    patientInvestigation:IPatient,
    serviceInvestigation:IServiceInvestigation,
    survey:ISurvey | null,
}

export interface IRequestPharmacy{
    id:number,
    status:RequestStatus,
    amountApproved:number,
    amountRequested:number,
    pharmacyItem:IPharmacyItem,
}

export type SurgeryStatus = RequestStatus.CHECKED_IN | RequestStatus.ANESTHESIOLOGIST_ACCEPTED | RequestStatus.COMPLETED | RequestStatus.PAYMENT_COMPLETED | RequestStatus.READY_FOR_SURGERY | RequestStatus.CANCELED | RequestStatus.PENDING_ANESTHESIOLOGIST | RequestStatus.ANESTHESIOLOGIST_REJECTED | RequestStatus.PENDING_PURCHASE_SURGERY_PROTHESIS | RequestStatus.COMPLETED | RequestStatus.PENDING_PAYMENT | RequestStatus.ACCEPTED | RequestStatus.PENDING_PAYMENT_AFTER_VPA | RequestStatus.PAYMENT_COMPLETED_AFTER_VPA;

export interface IRequest{
    id:number,
    submissionPatient:any,
    type:number,
    status : RequestStatus,
    investigation:any,
    researcher:IResearcher,
    requestsPharmacy:IRequestPharmacy[],
    departmentRequest:IDepartment,
    /**
     * SHER-910: the service the request came FROM, snapshotted by the API when it was created —
     * as opposed to `departmentRequest`, which is where it is going. Both are null for every
     * request created before SHER-910 shipped, and stay null afterwards whenever the requesting
     * doctor's unit memberships do not single out one service; the API never guesses. Render a
     * null as "Non renseigné", never as the doctor's current department.
     */
    // Optional, not just nullable: the API adds these relations to the request LIST queries only,
    // so a payload from any other endpoint arrives with the keys absent rather than null.
    requesterDepartment?:IDepartment | null,
    requesterUnit?:IUnit | null,
    requestsServiceInvestigation: IRequestServiceInvestigation[];
    patientInvestigation:IPatient,
    surveyRequest:ISurvey,
    typeSpecificData: SurgeryRequestData,
    createdAt: Date;
    updatedAt: Date;
    completedAt: Date;
    appointment?:IAppointment;
    /**
     * SHER-236: for a surgical request, the statuses the API will accept next. The
     * rules depend on the linked bill and on the request's transition history, so
     * only the server can evaluate them. Absent on non-surgical requests.
     */
    nextStatuses?:SurgeryStatus[];
    /**
     * SHER-236: whether the invoice still has a balance. Status cannot answer it — the
     * VPA-first pathway leaves a patient owing money while they sit in "VPA en attente" —
     * and this app holds no bill, so the server answers it.
     */
    owesPayment?:boolean;
}

export enum ServiceType{
    "LABORATORY" = 0,
    "IMAGING" = 1,  
    "CONSULTATION" = 2,  
    "SHOE" = 3,
    "SURGERY" = 4,
    "PHARMACY" = 5,
    
}

export enum RequestType {
    SERVICES = 0,
    CONSULTATION = 1,
    PHARMACY = 2,
    SURGERY = 3,
}